module.exports = __webpack_public_path__ + "static/WhenThePastWasAround8-185581fa5603699cf5568968cc8d25f5.webp";